export default "__VITE_ASSET__DVwd4W2X__"